<template>
  <div style="display: flex;height: 100%">
    <cargo-left-right-resize
      :left-style="{flex:'none',width:'425px','max-width':'28%'}"
      :right-style="{'overflow': 'hidden'}"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          config-module="2022082201"
          :show-side-bar="false"
          :grid-options="departmentTreeGrid.gridOptions"
          :column-defs="departmentTreeGrid.columnDefs"
          :row-data="departmentTreeGrid.rowData"
          grid-style="height:100%;"
        />
      </template>
      <template slot="right">
        <div style="display: flex;height: 100%">
          <cargo-left-right-resize
            :left-style="{flex:'none',width:'525px','max-width':'38%'}"
            :right-style="{'overflow': 'hidden'}"
            style="min-height:100%"
          >
            <template slot="left">
              <cargo-ag-grid
                config-module="2022082202"
                :show-side-bar="false"
                :grid-options="roleGrid.gridOptions"
                :column-defs="roleGrid.columnDefs"
                :row-data="roleGrid.rowData"
                grid-style="width:100%;height:100%;"
              />
            </template>
            <template slot="right">
              <div style="display: flex;height: 100%">
                <div>
                  <el-button style="position: relative;top: 50%;margin: 5px" type="primary" @click="addReportRole">&lt;<添加</el-button>
                </div>
                <cargo-ag-grid
                  config-module="2022082203"
                  :show-side-bar="false"
                  :grid-options="treeGroup.gridOptions"
                  :column-defs="treeGroup.columnDefs"
                  :row-data="treeGroup.rowData"
                  grid-style="height:100%;"
                />
              </div>
            </template>
          </cargo-left-right-resize>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import { getOfficeDeptTree } from '@/api/office'
import { getLoading } from '@/utils/utilBaseElement'
import { getRoleReprotPrivilegeTree, saveReportPrivilege } from '@/api/privilege'
import { DocumentManage } from '@/utils/commonUtil'
import * as reportApi from '@/api/report'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'

export default {
  name: 'PrivilegeConfig',
  components: { cargoLeftRightResize },
  data() {
    return {
      documentManage: new DocumentManage(),
      departmentTreeGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SystemMaintenance.Company'),
            width: 400,
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                console.log(params.data)
                const iconName = params.data.type !== 3 ? '' : 'grid-icon-disabled'
                const color = params.data.type !== 3 ? '#' : '#e6a23c'
                const name = (!this.isZh && params.data.englishName) ? params.data.englishName : params.data.chineseName
                const value = (params.data.code ? '[' + params.data.code + ']' : '') + name
                return params.data.type === 3 ? `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
                </svg>${value}` : value
              },
              checkbox: false
            },
            tooltipValueGetter: (params) => {
              return ''
            }
          },
          onRowClicked: this.onRowClick
        },
        columnDefs: [],
        rowData: []
      },
      roleGrid: {
        gridOptions: {},
        columnDefs: [{
          headerName: this.$t('SystemMaintenance.ReportName'),
          field: 'chineseName',
          width: 400,
          cellRenderer: params => {
            return (!this.isZh && params.data.englishName) ? params.data.englishName : params.data.chineseName
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Operation'),
          field: '',
          width: 100,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('delRolePsEventHandler')
            return `<a onclick="${methodPath}('${params.data.uuid}')">x</a>`
          }
        }
        ],
        rowData: []
      },
      treeGroup: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SystemMaintenance.Report'),
            width: 660,
            cellRendererParams: {
              // suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                console.log(params.data)
                const iconName = params.data.type !== 3 ? '' : 'grid-icon-disabled'
                const color = params.data.type !== 3 ? '#' : '#e6a23c'
                const name = (!this.isZh && params.data.englishName) ? params.data.englishName : params.data.chineseName
                const value = (params.data.code ? '[' + params.data.code + ']' : '') + name
                return params.data.type === 3 ? `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
                </svg>${value}` : value
              },
              checkbox: params => { // 是否显示checkBox
                const current = params.data
                if (!current) {
                  return false
                }
                return current['leaf']
              }
            }
          }
        },
        columnDefs: [],
        rowData: []
      },
      needCheckBox: false,
      roleUuid: ''
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {
    const self = this
    this.documentManage.set('delRolePsEventHandler', function(data) {
      self.delRolePsEventHandler(data)
    })
  },
  created() {
    const loading = getLoading()
    getOfficeDeptTree().then(res => {
      console.log('公司部门角色树')
      this.departmentTreeGrid.rowData = [...res.data]
    })
    reportApi.reportTree({ branchId: this.$store.getters.currentOfficeId }).then(resp => {
      this.treeGroup.rowData = [...resp.data]
    }).finally(() => {
      loading.close()
    })
  },
  methods: {
    onRowClick(params) {
      this.roleUuid = ''
      if (params.data.type === 3) {
        // 加载角色权限
        this.reloadPrivileges(params.data.uuid)
        this.roleUuid = params.data.uuid
      } else {
        this.roleGrid.rowData = []
      }
    },
    filterNoReportPs(privileges) {
      const old = []
      for (const ps of privileges) {
        if (ps.category === 'report') {
          if (!old.includes(ps)) {
            old.push(ps)
          }
        }
      }
      return old
    },
    async addReportRole() {
      let rows = this.treeGroup.gridOptions.api.getSelectedRows()
      // 过滤出叶子节点
      rows = rows.filter(row => row.leaf === true)
      if (this.checked(rows)) {
        const reports = await this.converReportPrivilege(rows)
        if (reports) {
          const loading = getLoading()
          saveReportPrivilege(reports).then(resp => {
            this.$message.success(this.$t('SystemMaintenance.PermissionAddedSuccessfully'))
            this.reloadPrivileges(this.roleUuid)
          }).finally(() => loading.close())
        }
      }
    },
    checked(items) {
      const cell = this.departmentTreeGrid.gridOptions.api.getFocusedCell()
      const { rowsToDisplay } = this.departmentTreeGrid.gridOptions.api.getModel()
      const node = cell ? rowsToDisplay[cell.rowIndex] : null
      const data = node ? node.data : null
      if (!data || data.type !== 3) {
        this.$message.info(this.$t('SystemMaintenance.PleaseOneOrMoreRoles'))
        return false
      }
      if (items.length === 0) {
        this.$message.info(this.$t('SystemMaintenance.PleaseReportLinkedToRole'))
        return false
      }
      return true
    },
    async converReportPrivilege(selectItems) {
      const reportRoles = []
      const needCheckBox = this.needCheckBox
      if (needCheckBox) {
        for (const role of this.departmentTreeGrid.rowData) {
          const rtPrivilege = {}
          rtPrivilege.roleUuid = role.uuid
          rtPrivilege.reports = []
          // 加载角色权限
          const privileges = await getRoleReprotPrivilegeTree(role.uuid).then(res => this.filterNoReportPs(res.data))
          this.getRolePrivileges(privileges, rtPrivilege.reports)
          this.getSelectItemPrivileges(selectItems, rtPrivilege.reports)

          reportRoles.push(rtPrivilege)
        }
      } else {
        const reportPrivilege = {}
        reportPrivilege.roleUuid = this.roleUuid
        reportPrivilege.reports = []
        this.getRolePrivileges(this.roleGrid.rowData, reportPrivilege.reports)
        this.getSelectItemPrivileges(selectItems, reportPrivilege.reports)

        reportRoles.push(reportPrivilege)
      }
      return reportRoles
    },
    getRolePrivileges(privileges, reports) {
      if (privileges != null && privileges.length > 0) {
        for (const p of privileges) {
          if (p.category === 'report') {
            const report = {}
            report.id = p.shape
            report.name = p.name
            report.englishName = p.englishName
            reports.push(report)
          }
        }
      }
    },
    getSelectItemPrivileges(selectItems, reports) {
      for (const xml of selectItems) {
        const index = reports.findIndex(re => re.id === xml.reportId)
        if (index > -1) {
          continue
        }
        const report = {}
        report.id = xml.reportId
        report.name = xml.name
        report.englishName = xml.englishName
        reports.push(report)
      }
    },
    async delRolePsEventHandler(rowUuid) {
      await this.$confirm(this.$t('SystemMaintenance.AreToDeleteTheRole'), this.$t('Message.Prompt'), {
        closeOnClickModal: false,
        type: 'info'
      })
      if (!this.roleUuid) return
      const p = this.roleGrid.rowData.find(row => row.uuid === rowUuid)
      if (!p) return
      const rtPrivilege = {}
      rtPrivilege.roleUuid = this.roleUuid
      rtPrivilege.reports = []
      const index = this.roleGrid.rowData.findIndex(row => row.uuid === rowUuid)
      if (index > -1) {
        this.roleGrid.rowData.splice(index, 1)
      }
      this.getRolePrivileges(this.roleGrid.rowData, rtPrivilege.reports)
      const loading = getLoading()
      saveReportPrivilege([rtPrivilege]).then(resp => {
        this.$message.success(this.$t('SystemMaintenance.PermissionDeletedSuccessfully'))
        this.reloadPrivileges(this.roleUuid)
      }).finally(() => loading.close())
    },
    reloadPrivileges(roleUuid) {
      // 加载角色权限
      getRoleReprotPrivilegeTree(roleUuid).then(res => {
        this.roleGrid.rowData = this.filterNoReportPs(res.data)
        this.roleGrid.oldPrivilegeUuidList = res.data.map(item => {
          return item.uuid
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
